import { Elements } from "@stripe/react-stripe-js";
import { loadStripe } from "@stripe/stripe-js";
import { useNavigate } from "react-router-dom";
import SaveCardForm from "../components/SaveCardForm";

const stripePromise = loadStripe(process.env.REACT_APP_STRIPE_PUBLIC_KEY);

const AddPaymentCard = () => {
  const navigate = useNavigate();
  return (
    <Elements stripe={stripePromise}>
      <SaveCardForm
        onCardSaved={() => {
          navigate("/patient-dashboard");
        }}
      />
    </Elements>
  );
};

export default AddPaymentCard;
